<glxy-uploader-list
  *ngIf="fileTypes() === 'other'"
  class="upload-file-list"
  [files]="files()"
  (fileDeleted)="removeFile()"
  [ngClass]="{ empty: files.length === 0 }"
></glxy-uploader-list>
<glxy-image-list
  *ngIf="fileTypes() === 'image'"
  class="upload-file-list"
  [files]="files()"
  (delete)="removeFile()"
  [ngClass]="{ empty: files.length === 0 }"
></glxy-image-list>

<!--CV Insert Review Link-->
<inbox-insert-review-link #inboxInsertReviewLink (insertLink)="insertLink($event)"></inbox-insert-review-link>
<!--Partner to Create Payment Link-->
<inbox-insert-payment-link
  #inboxInsertPaymentLink
  [conversationDetail]="conversationDetail$ | async"
  (insertLink)="insertLink($event)"
></inbox-insert-payment-link>

<glxy-file-drag-drop
  [uploaderTarget]="inboxUploadFile.uploader"
  [uploadingBlocked]="isImpersonating === true || (isOpenAIChannel$ | async) === true"
>
  <glxy-chat-composer
    #chatComposer
    (send)="onSubmit($event)"
    [chatSources]="availableChatSources$ | async"
    [clearMessageTextOnSend]="clearMessageText"
    [disableSendEmptyText]="false"
    [textAreaMinRows]="2"
    [selectedChatSourceId]="selectedChatSourceId()"
    (selectedChatSourceIdChange)="selectedChatSourceId.set($event)"
    [processing]="disableButton$ | async"
    [disabled]="isComposerDisabled()"
    [glxyPopover]="impersonatedPopover"
    (mouseenter)="isImpersonating ? showImpersonatedPopovers() : hideImpersonatedPopovers()"
    (mouseleave)="hideImpersonatedPopovers()"
    [messageText]="prefilledMessage"
    [enterKeySendsMessage]="!isMobile"
  >
    <!--Composer action buttons-->
    <glxy-composer-actions [hidden]="isImpersonating || (isOpenAIChannel$ | async) === true">
      <button
        glxyComposerActionButton
        mat-icon-button
        aria-label="Show more actions"
        matTooltip="{{ 'INBOX.MORE_ACTIONS' | translate }}"
        [matMenuTriggerFor]="dynamicContentMenu"
        [hidden]="composerCollapsedActions.length === 0"
      >
        <mat-icon [inline]="true">add</mat-icon>
      </button>

      <!--Upload file && Voice recording-->
      <inbox-upload-file
        #inboxUploadFile
        [conversationDetail]="conversationDetail$ | async"
        (fileChanged)="setFile($event)"
        [enableVoiceRecording]="canAccessVoiceRecorder$ | async"
        [selectedChatSourceId]="selectedChatSourceId()"
      ></inbox-upload-file>
    </glxy-composer-actions>
    <glxy-composer-beside-send *ngIf="showPopover$ | async" class="composer-beside-send">
      <button mat-icon-button (click)="toggleChannelInfoPopover()">
        <mat-icon cdkOverlayOrigin #popoverOrigin="cdkOverlayOrigin" class="info-icon">info_outline</mat-icon>
      </button>
      <glxy-popover
        *ngIf="popoverConfig$ | async as popoverConfig"
        [isOpen]="showChannelInfoPopover"
        [hasBackdrop]="true"
        [showBackdrop]="true"
        [hasArrow]="true"
        (backdropClick)="closeChannelInfoPopover()"
        [origin]="popoverOrigin"
      >
        <glxy-popover-title>
          {{ popoverConfig.title | translate }}
        </glxy-popover-title>
        <div>
          <p [innerHTML]="popoverConfig.contentFirst | translate"></p>
          <p>{{ popoverConfig.contentSecond | translate }}</p>
        </div>
        <glxy-popover-actions>
          <button mat-stroked-button color="primary" (click)="closeChannelInfoPopover()">
            {{ 'INBOX.CLOSE' | translate }}
          </button>
        </glxy-popover-actions>
      </glxy-popover>
    </glxy-composer-beside-send>

    <!--Popover message if a user is impersonated-->
    <glxy-popover #impersonatedPopover [isOpen]="showImpersonatedPopover" [positions]="TOOLTIP_BOTTOM_RIGHT">
      <glxy-popover-title>{{ 'INBOX.POPOVER.IMPERSONATION_TITLE' | translate }}</glxy-popover-title>
      {{ 'INBOX.POPOVER.IMPERSONATION_TEXT' | translate }}
    </glxy-popover>
  </glxy-chat-composer>

  <mat-menu #dynamicContentMenu="matMenu">
    <ng-container *ngFor="let item of composerCollapsedActions">
      <button *ngIf="item.visible | async" mat-menu-item (click)="item.onClick()" [matMenuTriggerFor]="item.matMenu">
        <mat-icon>{{ item.icon }}</mat-icon>
        <div class="menu-text">
          {{ item.action | translate }}
        </div>
      </button>
    </ng-container>
  </mat-menu>
</glxy-file-drag-drop>
